export enum MMPDefaults {
  Years = 5,
  Miles = 18000
}
